import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4109518a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex-container-row align-center gap5"
}
const _hoisted_2 = ["title", "onClick"]
const _hoisted_3 = {
  key: 1,
  class: "flex-container-row align-center gap5"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = {
  style: {"padding":"16px 24px","min-width":"350px","text-align":"left"},
  class: "flex-container-col gap10"
}
const _hoisted_9 = {
  class: "flex-container-col",
  style: {"gap":"4px"}
}
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = {
  key: 0,
  class: "validation-error"
}
const _hoisted_12 = {
  style: {"padding":"16px 24px","text-align":"left"},
  class: "flex-container-col gap10"
}
const _hoisted_13 = { class: "delete-proposal-box" }
const _hoisted_14 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_button = _resolveComponent("k-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_my_grid = _resolveComponent("my-grid")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_dialog_actions_bar = _resolveComponent("dialog-actions-bar")!
  const _component_app_dialog = _resolveComponent("app-dialog")!
  const _component_order_proposal_url_dialog = _resolveComponent("order-proposal-url-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_my_grid, {
      data: _ctx.gridRows,
      columns: _ctx.columns,
      "initial-sort": _ctx.initialSort,
      filterable: true,
      groupable: false,
      pageable: true,
      "page-size": 25
    }, {
      customTemplate1: _withCtx(({props}) => [
        (props.field === 'orderProposalNoFormatted')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("a", {
                class: "grid-id-link",
                title: _ctx.localize('ShowOrderProposal'),
                onClick: _withModifiers(($event: any) => (_ctx.viewCart(props.dataItem)), ["prevent"])
              }, _toDisplayString(props.dataItem.orderProposalNoFormatted), 9, _hoisted_2),
              _createVNode(_component_k_button, {
                size: 'small',
                icon: 'link-horizontal',
                class: "button-ghost",
                onClick: ($event: any) => (_ctx.showUrlDialogFor(props.dataItem)),
                title: _ctx.localize('ShowLinkForOrderProposal')
              }, null, 8, ["onClick", "title"])
            ]))
          : (props.field === 'expirationDateLocal')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", {
                  class: _normalizeClass(["status-dot", props.dataItem.expirationColor])
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(props.dataItem.expirationDateFormatted), 1),
                _createVNode(_component_k_button, {
                  size: 'small',
                  icon: 'edit',
                  class: "button-ghost",
                  onClick: ($event: any) => (_ctx.showExtendDialog(props.dataItem)),
                  title: _ctx.localize('ChangeValidityPeriod')
                }, null, 8, ["onClick", "title"])
              ]))
            : (props.field === 'totalPriceText')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  (!_ctx.pricesLoaded)
                    ? (_openBlock(), _createBlock(_component_loader, {
                        key: 0,
                        size: "16px"
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(props.dataItem.totalPriceText), 1)
                      ], 64))
                ]))
              : (props.field === 'createdLocal')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(props.dataItem.createdFormatted), 1))
                : (props.field === 'actions')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_k_button, {
                        size: 'small',
                        icon: 'delete',
                        class: "button-ghost-red",
                        onClick: ($event: any) => (_ctx.showDeleteConfirmation(props.dataItem)),
                        title: _ctx.localize('Delete')
                      }, null, 8, ["onClick", "title"])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(props.dataItem[props.field]), 1))
      ]),
      _: 1
    }, 8, ["data", "columns", "initial-sort"]),
    (_ctx.extendDialogVisible)
      ? (_openBlock(), _createBlock(_component_app_dialog, {
          key: 0,
          title: _ctx.localize('ChangeValidityPeriod'),
          onClose: _ctx.closeExtendDialog
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.localize('ValidUntil')), 1),
                _createVNode(_component_date_picker, {
                  value: _ctx.extendDate,
                  min: _ctx.minExtendDate,
                  format: _ctx.kendoDateFormat,
                  class: "fw",
                  onChange: _ctx.onExtendDateChange
                }, null, 8, ["value", "min", "format", "onChange"]),
                (_ctx.extendDateError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.extendDateError), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_dialog_actions_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_k_button, {
                  class: "button-cancel",
                  onClick: _ctx.closeExtendDialog
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('Cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_k_button, {
                  class: "button-save",
                  onClick: _ctx.onExtend,
                  icon: "save",
                  disabled: _ctx.isProcessing || !!_ctx.extendDateError
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('Save')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.deleteDialogVisible)
      ? (_openBlock(), _createBlock(_component_app_dialog, {
          key: 1,
          title: _ctx.localize('PleaseConfirm'),
          onClose: _ctx.closeDeleteDialog
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", null, _toDisplayString(_ctx.localize('DeleteOrderProposal')), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.selectedProposal?.orderProposalNoFormatted), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.selectedProposal?.name), 1)
              ])
            ]),
            _createVNode(_component_dialog_actions_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_k_button, {
                  class: "button-cancel",
                  onClick: _ctx.closeDeleteDialog
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('Cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_k_button, {
                  class: "button-delete",
                  onClick: _ctx.onDelete,
                  disabled: _ctx.isProcessing
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('Delete')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.urlDialogCartId != null)
      ? (_openBlock(), _createBlock(_component_order_proposal_url_dialog, {
          key: 2,
          "order-proposal-no": _ctx.urlDialogOrderProposalNo,
          name: _ctx.urlDialogName,
          "cart-id": _ctx.urlDialogCartId,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.urlDialogCartId = null))
        }, null, 8, ["order-proposal-no", "name", "cart-id"]))
      : _createCommentVNode("", true)
  ], 64))
}